import { render, staticRenderFns } from "./QRCodeGenerator.vue?vue&type=template&id=1ff18083&scoped=true"
import script from "./QRCodeGenerator.vue?vue&type=script&lang=js"
export * from "./QRCodeGenerator.vue?vue&type=script&lang=js"
import style0 from "./QRCodeGenerator.vue?vue&type=style&index=0&id=1ff18083&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff18083",
  null
  
)

export default component.exports